import React from "react";
import { Container } from "react-bootstrap";
import { Base } from "../../components/RootLayout";
import * as Assets from "../../utils/svg_assets";
import TopNavigation from "../../components/TopNavigation";
import { FitureUnderDevelopmentBody } from "../../components/FitureUnderDevelopment";

const UnderDevelopment = () => {
  return (
    <Base>
      <TopNavigation
        titlePage=""
        toPath={-1}
        setBorder={true}
        showLeftIcon={true}
        showRightIcon={false}
        iconLeft={Assets.iconBack}
        iconRight={Assets.iconSetting}
        rightEvent={false}
      />
      <Container>
        <FitureUnderDevelopmentBody info="This content still under development!"></FitureUnderDevelopmentBody>
      </Container>
    </Base>
  );
};

export default UnderDevelopment;
